"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidString = (source) => {
    if (source && source.length > 0) {
        return true;
    }
    return false;
};
//# sourceMappingURL=validation.service.js.map